import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

type CommunityManagerContextState = Readonly<{
  isShowCreateMessageForm: boolean;
  setIsShowCreateMessageForm: (value: boolean) => void;
  editBroadCastId: string;
  setEditBroadCastId: (value: string) => void;
  isCommunityLoading: boolean;
  setIsCommunityLoading: (value: boolean) => void;
  isViewBroadCastPage: boolean;
  setIsViewBroadCastPage: (value: boolean) => void;
}>;

const CommunityManagerContext = createContext<CommunityManagerContextState>({
  isShowCreateMessageForm: false,
  setIsShowCreateMessageForm: () => null,
  editBroadCastId: '',
  setEditBroadCastId: () => null,
  isCommunityLoading: false,
  setIsCommunityLoading: () => null,
  isViewBroadCastPage: false,
  setIsViewBroadCastPage: () => null,
});

export const CommunityManagerContextProvider: React.FC<
  PropsWithChildren<Record<string, unknown>>
> = ({ children }: PropsWithChildren<Record<string, unknown>>) => {
  const [isShowCreateMessageForm, setIsShowCreateMessageForm] =
    useState<boolean>(false);

  const [isCommunityLoading, setIsCommunityLoading] = useState<boolean>(true);
  const [isViewBroadCastPage, setIsViewBroadCastPage] =
    useState<boolean>(false);
  const [editBroadCastId, setEditBroadCastId] = useState<string>('');

  return (
    <CommunityManagerContext.Provider
      value={{
        isShowCreateMessageForm,
        setIsShowCreateMessageForm,
        editBroadCastId,
        setEditBroadCastId,
        isCommunityLoading,
        setIsCommunityLoading,
        isViewBroadCastPage,
        setIsViewBroadCastPage,
      }}
    >
      {children}
    </CommunityManagerContext.Provider>
  );
};

export const useCm3Context = (): CommunityManagerContextState => {
  return useContext(CommunityManagerContext);
};
